const getSiteURL = (rootState) => rootState.ws.integration.settings.siteURL;

export default getSiteURL;
